import { EmptyState } from "@/shared/ui/core/EmptyState";

export function NoPermissionState() {
  return <EmptyState title="Không đủ quyền" />;
}
